import Vue from 'vue'

import Buefy from 'buefy'
import './styles.scss'

import VideoBackground from 'vue-responsive-video-background-player'

import App from './App.vue'
import router from './router'
Vue.component('video-background', VideoBackground)

Vue.use(Buefy)

// import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === 'production'

// Vue.use(VueAnalytics, {
//   id: "UA-84781434-1",
//   router,
//   debug: {
//     enabled: !isProd,
//     sendHitTask: isProd
//   }
// })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
